<template>
  <div class="modelReg">
    <div class="modelReg__grid">
      <div class="modelReg__title">
        <h3>{{ $t('modal.auth_modal_state.login.title') }}</h3>
      </div>

      <div v-if="loader" class="modelReg__alertLoading"></div>
      <div v-if="errorMessage" class="modelReg__alertError">{{ errorMessage }}</div>
      <div v-if="successMessage" class="modelReg__alertSuccess">{{ successMessage }}</div>


      <UForm class="modelReg__form" autocomplete="off">
        <UiBaseInputN
          v-model="form.email"
          :label="$t('modal.auth_modal_state.login.input_phone')"
          :placeholder="$t('modal.auth_modal_state.login.input_phone')"
          :error="v$.email.$error"
          :errors="v$.email.$errors"
          :show-error="true"
          @change="v$.email.$touch"
        ></UiBaseInputN>

        <UiBaseInputN
          v-model="form.password"
          type-input="password"
          :label="$t('modal.auth_modal_state.login.input_password')"
          :placeholder="$t('modal.auth_modal_state.login.input_password')"
          :error="v$.password.$error"
          :errors="v$.password.$errors"
          :show-error="true"
          @change="v$.password.$touch"
        ></UiBaseInputN>
        <p class="text-xs">Соглашаюсь с условиями сбора и обработки персональных данных и офертой.</p>



        <UiButtonMain
          class="btn"
          color="red"
          size="xl"
          :label="$t('modal.auth_modal_state.login.form_btn')"
          block
          type="submit"
          :disabled="v$.$invalid"
          @click.prevent="submitForm"
        ></UiButtonMain>

      </UForm>
    </div>
  </div>
</template>

<script setup>
/* v8 ignore file */
import { consola } from 'consola';
import { useVuelidate } from '@vuelidate/core';
import { useModalStore } from '@shared/model';
import { useAuthStore } from '~/features/auth';
import { useRulesForForm } from '@shared/lib';


// Яндекс ID авторизация больше не используется в админке
// Используется только в обычных модальных окнах авторизации
const props = defineProps({
  userData: {
    type: Object,
    required: true,
    default: () => ({
      email: '',
      password: '',
    }),
  },
});
const emit = defineEmits(['update-user-data']);
const storeModal = useModalStore();
const storeAuth = useAuthStore();

const logger = consola.withTag('AdminLogin');

const loader = ref(false);
const errorMessage = ref(null);
const successMessage = ref(null);
const { RulesForFormPassword, RulesForFormEmail } = useRulesForForm();

const form = ref({ ...props.userData });
const rules = computed(() => {
  return {
    email: RulesForFormEmail(),
    password: RulesForFormPassword(),
  };
});
const v$ = useVuelidate(rules, form);

const submitForm = async () => {
  v$.value.$validate();
  if (!v$.value.$error) {
    const params = {
      email: form.value.email,
      password: form.value.password,
    };
    loader.value = true;
    errorMessage.value = null;
    successMessage.value = null;

    try {
      await storeAuth.adminLogin(params);
      successMessage.value = 'Успешная авторизация';

      // Закрываем модальное окно через 1 секунду
      setTimeout(() => {
        storeModal.close();
      }, 1000);
    } catch (error) {
      logger.error('Ошибка авторизации администратора:', error);

      // Обработка новой структуры ошибок V2 API
      if (error?.data) {
        const errorData = error.data;
        if (Array.isArray(errorData.message)) {
          errorMessage.value = errorData.message.join(', ');
        } else if (errorData.message) {
          errorMessage.value = errorData.message;
        } else {
          errorMessage.value = 'Ошибка авторизации';
        }
      } else if (error?.message) {
        errorMessage.value = error.message;
      } else {
        errorMessage.value = 'Произошла неизвестная ошибка';
      }
    } finally {
      loader.value = false;
      // Автоматическое скрытие сообщений через 6 секунд
      setTimeout(() => {
        errorMessage.value = null;
        successMessage.value = null;
      }, 6000);
    }
  }
};


watch(form, (newForm) => {
  emit('update-user-data', newForm);
}, { deep: true });


</script>

<style scoped lang="scss">
.modelReg__centerEl {
  @apply flex justify-end;
}
</style>

